import { lazy } from '@loadable/component';
import { createFileRoute } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

const CashierTable = lazy(
    async () => (await import(/* webpackChunkName: "Cashiers" */ '@mews-commander/cashiers')).CashierTable
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Cashiers/Dashboard')({
    component: () => <CashierTable />,
    staticData: {
        title: TextKey.CashierPlural,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
